export default __webpack_public_path__ + "static/media/small.e5d931e5.jpg";